import React, { Component } from "react";
import CustomBoardRenewal from "../../components/CustomBoardRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import Color from "../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../components/CustomTextInput";
import CustomButton from "../../components/CustomButton";
import _ from "lodash";
import AuthManager from "../../../utils/AuthManager";
import Image from "../../../assets";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import * as selector from "../../../common/selectors";
import * as onlineRenewalSelector from "../../../common/selectors/onlineRenewal";
import * as renewalAction from "../../../common/actions/onlineRenewal";
import { connect } from "react-redux";
import LoadingOverlay from "../../components/LoadingOverlay";
import Box from "@material-ui/core/Box";
import ShowMoreText from "react-show-more-text";
import CustomDropDown from "../../components/CustomDropDown";
import * as policyAction from "../../../common/actions/policy";
import CustomToast from "../../components/CustomToast";

const salutationList = [
  { value: "DR", label: "DR" },
  { value: "MR", label: "MR" },
  { value: "MS", label: "MS" },
  { value: "MRS", label: "MRS" },
  { value: "MDM", label: "MDM" },
];

const ageRange = [
  { value: "0", label: "Hook customer" },
  { value: "1", label: "25 and below" },
  { value: "2", label: "26 to 30" },
  { value: "3", label: "31 to 35" },
  { value: "4", label: "36 to 40" },
  { value: "5", label: "41 to 45" },
  { value: "6", label: "46 to 50" },
  { value: "7", label: "51 to 55" },
  { value: "8", label: "56 to 60" },
  { value: "9", label: "61 to 70" },
  { value: "10", label: "71 and above" },
];

class SingtelLeads extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    this.state = {
      height: 0,
      width: 0,
      policyNo: "",
      isOnClickNext: false,
      localSalutation: "",
      localAgeRange: "",
      localName: "",
      localMobileNo: "",
      localEmail: "",
      localCampaignName: "",
      customToastStatus: false,
      customToastStatusV2: false,
      toastMessage: "",
      toastMessageV2: "",
      dateValue: `${today.getDate().toString().padStart(2, "0")}${(
        today.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}${today.getFullYear()}`,
      localConsentTime: "",
      hours: "",
      minutes: "",
      consentTimeErr: "",
      consentDateErr:"",
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    window.localStorage.removeItem("MyToken");
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.singtelPartnershipLeadsReqData !==
      this.props.singtelPartnershipLeadsReqData
    ) {
      if (this.props.singtelPartnershipLeadsReqData.Success) {
        const today = new Date();
        this.setState({
          customToastStatusV2: true,
          toastMessageV2:
            this.props.singtelPartnershipLeadsReqData.Message ||
            "Successfully submitted!",

          localSalutation: "",
          localAgeRange: "",
          localName: "",
          localMobileNo: "",
          localEmail: "",
          localCampaignName: "",
          localConsentTime:"",
          dateValue:`${today.getDate().toString().padStart(2, "0")}${(
            today.getMonth() + 1
          )
            .toString()
            .padStart(2, "0")}${today.getFullYear()}`
        });
      } else {
        this.setState({
          customToastStatus: true,
          toastMessage:
            this.props.singtelPartnershipLeadsReqData.Message || "Failed!",
        });
      }
    }
  };

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  //   onChangePolicyNo = (event) => {
  //     this.setState({ policyNo: event.target.value });
  //   };

  validateTextInput = () => {
    const { policyNo } = this.state;
    return _.isEmpty(policyNo);
  };

  customStylesEnquiryType = (emptyEnquiry) => ({
    option: (provided, state) => ({
      ...provided,
      color: Color.primaryTextColor,
      backgroundColor: state.isSelected ? "#f0f0f0" : "white",
      fontFamily: "Muli",
      fontSize: "15px",
    }),
  });

  handleSelectedSalutation = (selectedSalutation) => {
    this.setState({ localSalutation: selectedSalutation });
    console.log("selectedSalutation", selectedSalutation);
  };

  handleSelectedAgeRange = (selectedAge) => {
    this.setState({ localAgeRange: selectedAge });
    console.log("selectedSalutation", selectedAge);
  };

  onChangeLocalName = (e) => {
    this.setState({ localName: e.target.value });
    if (e.target.value === "") {
      this.setState({
        localNameErr: true,
      });
      return;
    } else {
      this.setState({
        localNameErr: false,
      });
    }
  };
  onChangeLocalMobileNo = (e) => {
    if(e.target.value.length > 8){
      return;
    }
    this.setState({ localMobileNo: e.target.value });
    const phoneNumPattern = /^[89]\d{7}$/;
    if (phoneNumPattern.test(e.target.value) && e.target.value.length === 8) {
      this.setState({
        phoneNumErr: false,
      });
    } else {
      this.setState({
        phoneNumErr: true,
      });
    }
  };

  onChangeLocalCampaignName = (e) => {
    this.setState({ localCampaignName: e.target.value });
    if (e.target.value === "") {
      this.setState({
        campNameErr: true,
      });
      return;
    } else {
      this.setState({
        campNameErr: false,
      });
    }
  };

  onChangeLocalEmail = (e) => {
    this.setState({ localEmail: e.target.value });
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailReg.test(e.target.value)) {
      this.setState({
        emailErr: true,
      });
    } else {
      this.setState({
        emailErr: false,
      });
    }
  };

  onClickSubmit = (e) => {
    if (this.state.localSalutation === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Pease specify a value for Salutation.",
      });
      return;
    }
    if (this.state.localAgeRange === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Pease specify a value for Age Range.",
      });
      return;
    }
    if (this.state.localName === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Pease specify a value for Name.",
      });
      return;
    }
    if (this.state.localEmail === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Pease specify a value for Email.",
      });
      return;
    }
    if (this.state.localMobileNo === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Pease specify a value for Mobile No.",
      });
      return;
    }
    if (this.state.localCampaignName === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Pease specify a value for Campaign Name.",
      });
      return;
    }
    if (this.state.localConsentTime === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Pease specify a value for Consent Time.",
      });
      return;
    }
    if (this.state.localConsentDate === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "Pease specify a value for Consent Date.",
      });
      return;
    }
    const {localNameErr,phoneNumErr,emailErr,campNameErr,consentDateErr,consentTimeErr} = this.state;
    if(localNameErr || phoneNumErr || emailErr || campNameErr || consentDateErr || consentTimeErr){
      this.setState({
        customToastStatus: true,
        toastMessage: "Input value invalid or empty!",
      });
      return;
    }
    console.log("localdatetime",this.state.dateValue,this.state.localConsentTime)
    const year = this.state.dateValue[4] + this.state.dateValue[5] + this.state.dateValue[6] +this.state.dateValue[7];
    const month = this.state.dateValue[2] + this.state.dateValue[3];
    const day = this.state.dateValue[0] + this.state.dateValue[1];
    const hour = this.state.localConsentTime[0] + this.state.localConsentTime[1];
    const min = this.state.localConsentTime[2] + this.state.localConsentTime[3];
    const localConsentD = year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + "00";
    console.log("localConsentD",localConsentD)
    

    const data = {
      EmailAddress: this.state.localEmail,
      MobileNumber: "+65" + this.state.localMobileNo,
      LeadName: this.state.localName,
      CampaignCode: this.state.localCampaignName,
      ConsentedDate: localConsentD,
      Salutation: this.state.localSalutation.value,
      AgeRange: this.state.localAgeRange.value,
      AffluencyScore: null,
      LifeStage: null,
      ConsentType: this.state.localAgeRange.value === "0" ? "HOOK" : "WEB",
      NRIC: null,
      PolicyNumber: null,
      PdpaOptOutDate: null,
      IsWithdrawal: 0,
    };
    const { singtelPartnershipLeadsReq } = this.props;
    singtelPartnershipLeadsReq(data);
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  handleCloseCustomToastV2 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatusV2: false });
  };

  onChangeLocalConsentDate = (event) => {
    if (event.target.value.length > 8) {
      return;
    }
    
    const input = event.target.value;
    const dateRegex = /^(\d{2})(\d{2})(\d{4})$/;
    if (dateRegex.test(input)) {
      const [, day, month, year] = input.match(dateRegex);
      const parsedDate = new Date(`${year}-${month}-${day}`);
      if (!isNaN(parsedDate) && parsedDate.getDate() === parseInt(day)) {
        this.setState({ dateValue: input, consentDateErr: '' });
      } else {
        this.setState({ consentDateErr: 'Invalid date' });
      }
    } else {
      this.setState({ consentDateErr: 'Invalid input' });
    }
    this.setState({ dateValue: event.target.value });
    
  };

  onChangeLocalConsentTime = (e) => {
    const inputValue = e.target.value;
    // Check if the input is a valid 4-digit number
    if (inputValue.length > 4) {
      return;
    }
    if(inputValue.length === 1){
      if (inputValue > 2) {
        this.setState({
          localConsentTime: "",
          consentTimeErr: "Please enter a valid 24-hour time (e.g., 0830).",
        });
        return;
      }
    }
    if (inputValue.length > 1) {
      if (inputValue.slice(0, 2) > 23) {
        this.setState({
          localConsentTime: inputValue.slice(0, 1),
          consentTimeErr: "Please enter a valid 24-hour time (e.g., 0830).",
        });
        return;
      }
    }
    if (inputValue.length > 2) {
      if (inputValue.slice(0, 3) > 235) {
        this.setState({
          localConsentTime: inputValue.slice(0, 2),
          consentTimeErr: "Please enter a valid 24-hour time (e.g., 0830).",
        });
        return;
      }
    }
    if(inputValue.length > 2){
      if (inputValue[2] > 5) {
        this.setState({
          localConsentTime: inputValue.slice(0, 2),
          consentTimeErr: "Please enter a valid 24-hour time (e.g., 0830).",
        });
        return;
      }
    }
    if (inputValue.length > 3) {
      if (inputValue.slice(0, 4) > 2359) {
        this.setState({
          localConsentTime: inputValue.slice(0, 3),
          consentTimeErr: "Please enter a valid 24-hour time (e.g., 0830).",
        });
        return;
      }
    }
    if (/^\d{0,4}$/.test(inputValue)) {
      if (inputValue.length > 3) {
        this.setState({
          localConsentTime: inputValue,
          consentTimeErr: "",
        });
      } else {
        this.setState({
          localConsentTime: inputValue,
          consentTimeErr: "Please enter a valid 24-hour time (e.g., 0830).",
        });
      }
    } else {
      return;
    }
  };

  renderChildren = () => {
    const { classes, singtelPartnershipLeadsReqLoading } = this.props;
    const {
      policyNo,
      isOnClickNext,
      localSalutation,
      localAgeRange,
      localName,
      localMobileNo,
      localCampaignName,
      localEmail,
      dateValue,
      localConsentTime,
      inputValue,
    } = this.state;
    return (
      <Grid
        container
        direction={"column"}
        spacing={2}
        style={{
          paddingLeft: window.innerWidth < 800 ? "10%" : "22%",
          paddingRight: window.innerWidth < 800 ? "10%" : "22%",
          marginTop: window.innerWidth < 800 ? "26%" : "3%",
          overflow: window.innerWidth < 800 ? "scroll" : "none",
          height: window.innerWidth < 800 ? "130vh" : "",
          marginBottom:"100px"
          
        }}
        className={classes.scrollStyle}
      >
        <Grid item>
          <CustomText
            design={classes.renewNowTextStyle}
            style={{ color: "#2c3034" }}
          >
            Singtel Leads
          </CustomText>
        </Grid>
        <Grid
          item
          style={{
            display: "flex",
            flexDirection: window.innerWidth < 800 ? "column" : "row",
            justifyContent: "space-between",
          }}
        >
          {/* <CustomTextInput
            title={"Salutation"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={policyNo}
            // onChange={this.onChangePolicyNo}
            error={this.validateTextInput() && isOnClickNext}
            errorMessage={
              this.validateTextInput() && isOnClickNext
                ? "You must specify a value for this required field."
                : false
            }
          /> */}
          <Grid
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              marginBottom: window.innerWidth < 800 ? "7px" : "",
            }}
          >
            <Grid
              style={{ color: "#495057", fontSize: "16px", fontWeight: "500" }}
            >
              Salutation
            </Grid>
            <CustomDropDown
              value={localSalutation}
              options={salutationList}
              className={classes.dropDownStyle}
              placeholder={""}
              design={
                window.innerWidth < 800
                  ? classes.textInputContainerDropV2
                  : classes.textInputContainerDrop
              }
              onChange={this.handleSelectedSalutation}
              customStyles={this.customStylesEnquiryType(true)}
            />
          </Grid>

          <CustomTextInput
            title={"Name"}
            textstyle={classes.labelTextInputTextStyle}
            design={
              window.innerWidth < 800
                ? classes.textInputContainerV2
                : classes.textInputContainer
            }
            fullWidth={true}
            value={localName}
            onChange={this.onChangeLocalName}
            error={this.state.localNameErr}
            errorMessage={
              this.state.localNameErr
                ? "You must specify a value for this required field."
                : false
            }
          />
        </Grid>

        <Grid
          item
          style={{
            display: "flex",
            flexDirection: window.innerWidth < 800 ? "column" : "row",
            justifyContent: "space-between",
          }}
        >
          <CustomTextInput
            title={"Mobile Number"}
            textstyle={classes.labelTextInputTextStyle}
            design={
              window.innerWidth < 800
                ? classes.textInputContainerV2
                : classes.textInputContainer
            }
            fullWidth={true}
            value={localMobileNo}
            onChange={this.onChangeLocalMobileNo}
            error={this.state.phoneNumErr}
            errorMessage={
              this.state.phoneNumErr ? "Invalid Phone Number" : false
            }
            startAdornment={<div style={{ marginRight: "0.2rem" }}>+65 </div>}
          />
          {window.innerWidth < 800 && <div style={{ marginTop: "10px" }}></div>}
          <CustomTextInput
            title={"Email Address"}
            textstyle={classes.labelTextInputTextStyle}
            design={
              window.innerWidth < 800
                ? classes.textInputContainerV2
                : classes.textInputContainer
            }
            fullWidth={true}
            value={localEmail}
            onChange={this.onChangeLocalEmail}
            error={this.state.emailErr}
            errorMessage={this.state.emailErr ? "Email is not valid." : false}
          />
        </Grid>

        <Grid
          item
          style={{
            display: "flex",
            flexDirection: window.innerWidth < 800 ? "column" : "row",
            justifyContent: "space-between",
          }}
        >
          <Grid
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              marginBottom: window.innerWidth < 800 ? "7px" : "",
            }}
          >
            <Grid
              style={{ color: "#495057", fontSize: "16px", fontWeight: "500" }}
            >
              Age Range
            </Grid>
            <CustomDropDown
              value={localAgeRange}
              options={ageRange}
              className={classes.dropDownStyle}
              placeholder={""}
              design={
                window.innerWidth < 800
                  ? classes.textInputContainerDropV2
                  : classes.textInputContainerDrop
              }
              onChange={this.handleSelectedAgeRange}
              customStyles={this.customStylesEnquiryType(true)}
            />
          </Grid>
          <CustomTextInput
            title={"Campaign Name"}
            textstyle={classes.labelTextInputTextStyle}
            design={
              window.innerWidth < 800
                ? classes.textInputContainerV2
                : classes.textInputContainer
            }
            fullWidth={true}
            value={localCampaignName}
            onChange={this.onChangeLocalCampaignName}
            error={this.state.campNameErr}
            errorMessage={
              this.state.campNameErr
                ? "You must specify a value for this required field."
                : false
            }
          />
        </Grid>

        <Grid
          item
          style={{
            display: "flex",
            flexDirection: window.innerWidth < 800 ? "column" : "row",
            justifyContent: "space-between",
          }}
        >
          <CustomTextInput
            title={"Consent Date (in DDMMYYYY)"}
            textstyle={classes.labelTextInputTextStyle}
            design={
              window.innerWidth < 800
                ? classes.textInputContainerV2
                : classes.textInputContainer
            }
            fullWidth={true}
            value={dateValue}
            onChange={this.onChangeLocalConsentDate}
            error={this.state.consentDateErr !=="" ? true:false}
            errorMessage={this.state.consentDateErr !== "" ? this.state.consentDateErr : false}
          />
          {window.innerWidth < 800 && <div style={{ marginTop: "10px" }}></div>}
          <CustomTextInput
            title={"Consent Time (in HHMM)"}
            textstyle={classes.labelTextInputTextStyle}
            design={
              window.innerWidth < 800
                ? classes.textInputContainerV2
                : classes.textInputContainer
            }
            fullWidth={true}
            value={localConsentTime}
            onChange={(e) => this.onChangeLocalConsentTime(e)}
            error={this.state.consentTimeErr}
            errorMessage={
              this.state.consentTimeErr !== ""
                ? this.state.consentTimeErr
                : false
            }
          />
        </Grid>

        <Grid item>
          {/* <div style={{ paddingRight: "1em", display: "inline-block" }}>
            <CustomButton
              title={"Back"}
              design={classes.backButton}
              textstyle={classes.backButtonTextStyle}
              onClick={this.onClickBack}
            />
          </div> */}
          <div style={{ display: "inline-block" }}>
            <CustomButton
              title={"Submit"}
              design={classes.nextButtonStyle}
              onClick={this.onClickSubmit}
              id={"clickRenewalButton"}
            />
          </div>
        </Grid>

        {/* <Grid item>
          <CustomText design={classes.bottomTextStyle} component="div">
            For customers with an Online Account, you may log in{" "}
            <CustomText
              display={"inline"}
              design={classes.highLightedTextStyle}
              onClick={this.onClickHere}
            >
              here
            </CustomText>{" "}
            to use your eWallet credits.
          </CustomText>
        </Grid> */}
      </Grid>
    );
  };

  render() {
    const {
      classes,
      checkRenewabilityLoading,
      singtelPartnershipLeadsReqLoading,
    } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        <Helmet>
          <title>Singtel Leads</title>
        </Helmet>
        {/* <div className={classes.headerStyle} style={{display:"inline-block"}}>
          <div  >
            <img src={Image.renewalHeader} style={{height:"42px"}} />
          </div>
          <div style={{textAlign:"center"}}>
            <CustomText design={classes.headerTextStyle}>
              Policy Renewal
            </CustomText>
          </div>
        </div> */}
        {this.renderChildren()}
        {singtelPartnershipLeadsReqLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
        <CustomToast
          open={this.state.customToastStatusV2}
          handleCloseCustomToast={this.handleCloseCustomToastV2}
          title={this.state.toastMessageV2}
          success
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 39,
    marginTop: 5,
    width: "25vw",
  },
  textInputContainerDrop: {
    // height: 50,
    marginTop: 8,
    width: "25vw",
  },
  textInputContainerV2: {
    height: 39,
    marginTop: 5,
    // width: "35vw",
  },
  textInputContainerDropV2: {
    // height: 50,
    marginTop: 8,
    // width: "35vw",
  },
  nextButtonStyle: {
    width: 150,
    marginTop: 10,
    marginBottom: 10,
  },
  nextTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
    marginBottom: 10,
  },
  errorTextStyle: {
    color: "red",
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  headerStyle: {
    backgroundColor: "#5b5b5b",
  },
  headerTextStyle: {
    color: "white",
    textAlign: "center",
    fontSize: "28px",
  },
  scrollStyle:{
    "&::-webkit-scrollbar": { width: "1px" },
    "&::-webkit-scrollbar-track": { background: "#f1f2f8" },
    "&::-webkit-scrollbar-thumb": { background: "#E0E0E0" },
  }
});

// export default withStyles(styles, { withTheme: true })(
//   withRouter(OnlineRenewal)
// );

function mapStateToProps(state) {
  return {
    singtelPartnershipLeadsReqLoading: selector.singtelPartnershipLeadsReqLoading(
      state
    ),
    singtelPartnershipLeadsReqData: selector.singtelPartnershipLeadsReqData(
      state
    ),
    singtelPartnershipLeadsReqStatus: selector.singtelPartnershipLeadsReqStatus(
      state
    ),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    singtelPartnershipLeadsReq: (submitData) =>
      dispatch(policyAction.singtelPartnershipLeadsReq(submitData)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(SingtelLeads)));
